import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BlockUIModule } from 'ng-block-ui';
import { NgbAlertModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskModule } from 'ngx-mask';

import { HarpCommonModule } from '@shared/shared.module';

import { AdoConfigService } from './services/ado-config.service';
import { AltLayoutComponent } from './components/alt-layout/alt-layout.component';
import { TermsOfUseComponent } from './components/terms-of-use/terms-of-use.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { LoginComponent } from './components/login/login.component';
import { LoginRedirectInterimComponent } from './components/login-redirect-interim/login-redirect-interim.component';
import { SelectDestinationComponent } from './components/select-destination/select-destination.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { PivCardRecoveryComponent } from './components/piv-card-recovery/piv-card-recovery.component';
import { MfaComponent } from './components/mfa/mfa.component';
import { MfaSetupComponent } from './components/mfa-setup/mfa-setup.component';
import { MfaChallengeComponent } from './components/mfa-challenge/mfa-challenge.component';
import { LayoutComponent } from './components/layout/layout.component';
import { HelpComponent } from '../../components/help/help.component';

import { LoginRoutingModule } from './login-routing.module';
import { AccountRecoveryComponent } from './components/account-recovery/account-recovery.component';
import { ContactComponent } from './components/contact/contact.component';
import { AccessibilityComponent } from './components/accessibility/accessibility.component';
import { CommonModule } from '@angular/common';
import { HarpLoginService } from './services/harp-login.service';
import { FactorService } from './services/factor.service';
import { NavigationService } from './services/navigation.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './services/auth.interceptor';
import { HelpAccordionComponent } from '../../components/help/help-accordion/help-accordion.component';
import { ResetPasswordService } from './services/reset-password.service';
import { FullRecoveryService } from './services/full-recovery.service';
import { ForgotAccountInfoComponent } from './components/forgot-account-info/forgot-account-info.component';
import { FullRecoveryComponent } from './components/full-recovery/full-recovery.component';
import { ChallengeQuestionFormComponent } from './components/challenge-question-form/challenge-question-form.component';
import { SelectDestinationService } from './services/select-destination.service';
import { ArrowLinksComponent } from './components/contact/arrow-links/arrow-links.component';
import { ContactDetailsComponent } from './components/contact/contact-details/contact-details.component';
import { MfaDeviceTableComponent } from './components/mfa-setup/mfa-device-table/mfa-device-table.component';
import { ChallengeQuestionComponent } from './components/challenge-question/challenge-question.component';
import { UserUnlockService } from './services/user-unlock.service';
import { AccountLockedComponent } from './components/account-locked/account-locked.component';
import { ResetChallengeQuestionComponent } from './components/reset-challenge-question/reset-challenge-question.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ChallengeQuestionUnlockComponent } from './components/challenge-question-unlock/challenge-question-unlock.component';
import { PasswordWarningComponent } from './components/password-warning/password-warning.component';
import { BlockCopyPasteDirective } from './util/block-copy-paste.directive';
import { AdoLogoutComponent } from './components/ado-logout/ado-logout.component';

@NgModule({
  declarations: [
    SelectDestinationComponent,
    ResetPasswordComponent,
    PrivacyPolicyComponent,
    PivCardRecoveryComponent,
    MfaComponent,
    MfaSetupComponent,
    MfaChallengeComponent,
    LoginComponent,
    LoginRedirectInterimComponent,
    HelpComponent,
    TermsOfUseComponent,
    LayoutComponent,
    AltLayoutComponent,
    AccountRecoveryComponent,
    ContactComponent,
    AccessibilityComponent,
    LayoutComponent,
    HelpAccordionComponent,
    ForgotAccountInfoComponent,
    FullRecoveryComponent,
    ChallengeQuestionFormComponent,
    ArrowLinksComponent,
    ContactDetailsComponent,
    MfaDeviceTableComponent,
    ChallengeQuestionComponent,
    AccountLockedComponent,
    ResetChallengeQuestionComponent,
    ChangePasswordComponent,
    ChallengeQuestionUnlockComponent,
    PasswordWarningComponent,
    BlockCopyPasteDirective,
    AdoLogoutComponent,
  ],
  imports: [
    BlockUIModule.forRoot(),
    NgxMaskModule.forRoot(),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LoginRoutingModule,
    NgbAlertModule,
    NgbModule,
    HarpCommonModule,
  ],
  providers: [
    AdoConfigService,
    HarpLoginService,
    FactorService,
    NavigationService,
    ResetPasswordService,
    FullRecoveryService,
    SelectDestinationService,
    UserUnlockService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
})
export class LoginModule {}
